import { InputLabel, Select } from '@material-ui/core';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Link } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import { ApplicationState } from '~/store';
import { AuthState } from '~/store/ducks/auth/types';
import { categoriaRequest } from '~/store/ducks/common/actions';
import { assuntoContactRequest } from '~/store/ducks/ContactDPOLogado/actions';
import { multipleLanguageRequest } from '~/store/ducks/language/actions';
import {
  FormControlLGPD,
  StyledButton,
  StyledTextField,
  Wrapper,
  WrapperTest,
} from './styles';

interface FormContact {
  identification_key: string;
  email: string;
  emailConfirmation: string;
}

interface FormErr {}

interface IProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  categoriaRequest: (company: any) => void;
  handleChangeOwnership: (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => void;
  ownership: number;
  handleChangeSubject: (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => void;
  subject: number;
  children: React.ReactNode;
  FormData: FormContact;
  FormErr?: {
    identification_key: string;
    email: string;
    emailConfirmation: string;
    ownership_type: string;
    subject: string;
  };
  sendContact?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  multipleLanguageRequest(language: string): void;
}

interface StateProps {
  language: any;
  auth: AuthState;
  common: any;
}

type Props = StateProps & IProps;

interface State {
  files: File[];
}

class contactDOP extends Component<Props> {
  state: State = {
    files: [],
  };

  componentDidMount() {
    const {
      //@ts-ignore
      assuntoContactRequest,
      multipleLanguageRequest,
      categoriaRequest,
      auth,
    } = this.props;

    document.title = 'Solicitar ajuda ao DPO | Portal LGPD';

    multipleLanguageRequest('ptbr');
    categoriaRequest(auth.company?.country_company_id);

    assuntoContactRequest(auth.company?.country_company_id);
  }

  handleChangefile = (files: File[]) => {
    this.setState({ files });
  };

  setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  render() {
    const {
      children,
      handleChange,
      handleChangeOwnership,
      ownership,
      handleChangeSubject,
      subject,

      language,
      FormData,
      //@ts-ignore
      assuntos,
      sendContact,
      FormErr,
      auth,
      common,
    } = this.props;

    return (
      <WrapperTest>
        <Wrapper>
          <div className="content-small">
            <div className="vrio-corp">
              <span>Vrio Corp</span>
            </div>

            <div className="welcome">
              <h2>{language?.login?.bemVindo}</h2>
              <h1>{language?.login?.LGPDSystem}</h1>
            </div>
          </div>
          <div className="container-form">
            <form action="">
              <div className="header">
                {auth.company?.country_company_id ? (
                  <img
                    src={this.setLogo(auth.company.country_company_id)}
                    alt={`logo ${auth.company?.company?.company_name?.toUpperCase()}`}
                  />
                ) : (
                  ''
                )}

                <h1>{language?.solicitarAjudaAoDPO?.solicitarAjudaAoDPO}</h1>
              </div>

              <InputMask
                mask="999.999.999-99"
                value={FormData.identification_key}
                onChange={handleChange}
                name="identification_key"
                disabled={false}
                maskChar=""
                children={() => (
                  <StyledTextField
                    identificationkeyerror={
                      !!FormErr?.identification_key ? true : false
                    }
                    id="identificationKey"
                    name="identification_key"
                    label="CPF"
                    variant="outlined"
                  />
                )}
              />

              <StyledTextField
                id="e-mail-adress"
                label={language?.solicitarAjudaAoDPO?.enderecoDeEmail}
                identificationkeyerror={
                  !!FormErr?.email || !!FormErr?.emailConfirmation
                    ? true
                    : false
                }
                variant="outlined"
                name="email"
                value={FormData.email}
                onChange={handleChange}
              />

              <StyledTextField
                id="repeat-e-mail-adress"
                label={language?.solicitarAjudaAoDPO?.redigiteOEnderecoDeEmail}
                identificationkeyerror={
                  !!FormErr?.emailConfirmation ? true : false
                }
                variant="outlined"
                name="emailConfirmation"
                value={FormData.emailConfirmation}
                onChange={handleChange}
              />

              <FormControlLGPD
                variant="outlined"
                ownershiptypeerror={!!FormErr?.ownership_type ? true : false}
              >
                <InputLabel htmlFor="ownershipType">Categoria</InputLabel>
                <Select
                  native
                  value={ownership}
                  onChange={handleChangeOwnership}
                  label="Categoria"
                  inputProps={{
                    name: 'ownershipType',
                    id: 'ownershipType',
                  }}
                >
                  <option aria-label="ownershipType" value="" />
                  {!!common.categoria[0] &&
                    common.categoria?.map((el: any) => {
                      return (
                        <option
                          key={el.data_holder_cat_id}
                          value={el.data_holder_cat_id}
                        >
                          {el.data_holder_cat_name}
                        </option>
                      );
                    })}
                </Select>
              </FormControlLGPD>

              <FormControlLGPD
                variant="outlined"
                ownershiptypeerror={!!FormErr?.subject ? true : false}
              >
                <InputLabel htmlFor="assunto">Assunto</InputLabel>
                <Select
                  native
                  value={subject}
                  onChange={handleChangeSubject}
                  label="Assunto"
                  inputProps={{
                    name: 'assunto',
                    id: 'assunto',
                  }}
                >
                  <option aria-label="assunto" value="" />
                  {assuntos.map((el: any, i: any) => (
                    <option key={i} value={el.contact_subject_id}>
                      {el.subject_ds}
                    </option>
                  ))}
                </Select>
              </FormControlLGPD>

              <div className="ReCAPTCHA">{children}</div>

              <div className="StyledButton-align">
                <StyledButton className="button-continue" onClick={sendContact}>
                  {!!language?.solicitarAjudaAoDPO?.enviar &&
                    language?.solicitarAjudaAoDPO?.enviar}
                </StyledButton>
              </div>
            </form>

            <div className="nav-options">
              <p>
                <Link to={`/${auth?.company?.path_alias_nm}`}>
                  {language?.solicitarAjudaAoDPO?.fazerLogin}
                </Link>
              </p>
              <p
                onClick={() => {
                  const toastrConfirmOptions = {
                    onOk: () => {},
                    onCancel: () => {},
                    okText: 'Ok',
                    disableCancel: true,
                  };

                  toastr.confirm(
                    `As informações previstas no artigo 18 da Lei Geral de Proteção de Dados estão no Portal LGPD da SKY.
                    Com o cadastro nesse Portal, você pode visualizar e gerenciar seus dados e exercer seus direitos. Você também pode
                    solicitar ajuda ao DPO sem possuir cadastro no Portal LGPD; basta preencher os dados no formulário e fazer a sua
                    solicitação. Ela será respondida por e-mail em até 15 dias.`,
                    toastrConfirmOptions,
                  );
                }}
              >
                <a style={{ cursor: 'pointer' }}>
                  {language?.solicitarAjudaAoDPO?.ajuda}
                </a>
              </p>
            </div>

            <p className="footer">
              {language?.solicitarAjudaAoDPO?.politicaGoogle.parte_1}{' '}
              <a
                href="https://policies.google.com/privacy?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.solicitarAjudaAoDPO?.politicaGoogle.parte_2}
              </a>{' '}
              {language?.solicitarAjudaAoDPO?.politicaGoogle.parte_3}{' '}
              <a
                href="https://policies.google.com/terms?hl=pt"
                target="_blank"
                rel="noopener noreferrer"
              >
                {language?.solicitarAjudaAoDPO?.politicaGoogle.parte_4}
              </a>{' '}
              {language?.solicitarAjudaAoDPO?.politicaGoogle.parte_5}
            </p>
          </div>
        </Wrapper>
      </WrapperTest>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  language: state.language.data,
  assuntos: state.ContactDPOLogado.data,
  auth: state.auth,
  common: state.common,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators(
    { assuntoContactRequest, multipleLanguageRequest, categoriaRequest },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(contactDOP);
